import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from 'src/app/services/alert.service';
import { DivisionService } from 'src/app/services/division.service';
import { DptmasterService } from 'src/app/services/dptmaster.service';
import { ExcelService } from 'src/app/services/excel.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import swal from 'sweetalert2';
@Component({
  selector: 'app-dbtproductcomponentmapping',
  templateUrl: './dbtproductcomponentmapping.component.html',
  styleUrls: ['./dbtproductcomponentmapping.component.scss'],

})
export class DbtproductcomponentmappingComponent implements OnInit {
  data = [];
  //public data: any[];
  dataSource = new MatTableDataSource(this.data);
  displayedColumns: string[] =['dbtProductType', 'Department', 'dbtComponentName', 'actions'];
  goDataGrid: any[];
  isShow: boolean;
  actionId: any;
  resultdata: any;
  expandedElement: any;
  panelOpenState = false;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('searchInput', { static: false }) searchInput: ElementRef;
  controlAccess: any;
  loading: boolean;

  constructor(
    public navigationService: NavigationService,
    private userSessionService: UserSessionService,
    private excelService: ExcelService,
    private translate: TranslateService,
    // private consummableService: ConsummableService,
    private alertService: AlertService,
    private router: Router,

    private dptMasterService: DptmasterService
    // private dptService: dptserv
  ) {
    this.controlAccess = this.userSessionService.getPageUrl(this.router.url);
  }

  ngOnInit() {
    this.get();
  }

  get() {
    this.loading = true;

    this.dptMasterService.getDbtProductComponentMapping(true).subscribe((res) => {
      this.dataSource = new MatTableDataSource(res);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.goDataGrid = res
    this.loading = false;

    })
  }

  expandUp(dataField) {
    this.expandedElement = {};
    this.expandedElement = dataField;
  }
  expandDown(dataField) {
    this.expandedElement = {};
    this.expandedElement = dataField;
    // localStorage.setItem('expandedElement', JSON.stringify(dataField));
  }

  
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  onRefresh() {
    this.searchInput.nativeElement.value = '';
    this.get();
  }

  add() {
    this.isShow = true;
    this.actionId = '0';
    this.resultdata = '';
  }
  editTarget(resultdata: any) {
    this.isShow = true;
    this.actionId = '1';
    this.resultdata = resultdata;
  }

  viewTarget(resultdata: any) {
    this.isShow = true;
    this.actionId = '2';
    this.resultdata = resultdata;
  }

  handelBack(event) {
    const val = event.value;
    this.isShow = val;
    this.get();
  }



}
